import { useMemo } from 'react'
import { useRouter } from './useRouter'

const useInPage = (paths?: string[]): boolean => {
  const router = useRouter()

  return useMemo(() => {
    if (!paths || paths.length === 0) {
      return false
    }

    return paths.includes(router.pathname)
  }, [paths, router.pathname])
}

export default useInPage
